import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  Box,
  Typography,
  IconButton,
  Stack,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { useState } from 'react';

export function AccordionSection() {
  const [isOpen, setIsOpen] = useState(false);

  const items = [
    '株式会社プロクラは、資料及び展示場予約の請求等（以下「資料請求等」といいます。）をしていただいた皆様からお預かりした個人情報を、皆様が本サービス上で資料請求等の対象として選択した企業等（当社の顧客企業、当社が本サービスを提供する上で必要な提携・契約関係を有する企業等をいいます。）に提供いたします。必須項目に不備があった場合、当該企業等からの各サービスを受けられないことがございますので、あらかじめご了承ください。',
    '資料請求等をしていただいた皆様からお預かりした個人情報は、企業等において、資料送付、展示場の予約等及びこれに付随する連絡・皆様と企業等との契約の締結・企業等によるサービス提供・皆様からのお問い合わせへの回答・各種イベントのご案内・関連物件または実例のお知らせ等の目的で利用・管理・保管されます。（詳細はプライバシーポリシーをご確認ください。）',
    '株式会社プロクラは本サービスを円滑に遂行するため、お預かりした個人情報を一定期間保管し、株式会社プロクラからサービス提供についてお電話もしくはSMSや電子メールにて確認のご連絡をさせていただくことがございます。',
    '株式会社プロクラにおける個人情報の取扱い、個人情報の開示・訂正・利用停止及びお問い合わせ窓口等についてはプライバシーポリシーをご覧ください。',
  ];

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box mt={3} width="100%">
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          cursor: 'pointer',
          justifyContent: 'center',
          textAlign: 'left',
        }}
        onClick={toggleAccordion}
      >
        <Typography
          variant="h4"
          color="primary"
          sx={{ textDecoration: 'underline' }}
        >
          個人情報の取り扱い及び電話SMS電子メールについて
        </Typography>
        <IconButton
          disableRipple
          sx={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
          }}
        >
          <ArrowDropDownIcon sx={{ fontSize: 50 }} />
        </IconButton>
      </Stack>

      {isOpen && (
        <Box width="100%">
          <List sx={{ listStyleType: 'disc', pl: 3 }}>
            {items.map((text, index) => (
              <ListItem key={index} sx={{ display: 'list-item', pl: 0 }}>
                <ListItemText
                  primary={
                    <Typography variant="body2" component="span">
                      {text}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
}
